import { BaseLightHelper } from "./_BaseLightHelper";
import { Mesh } from "three";
import { CorePointLightHelper } from "../../../../../core/lights/PointLight";
export class PointLightHelper extends BaseLightHelper {
  constructor() {
    super(...arguments);
    this._coreHelper = new CorePointLightHelper();
  }
  createObject() {
    return new Mesh();
  }
  buildHelper() {
    this._coreHelper.buildHelper(this._object);
  }
  update() {
    this._coreHelper.update(this._object, { helperSize: this.node.pv.helperSize, light: this.node.light });
  }
}
